const pxToEm = (number) => {
	return (
		number /
		parseFloat(
			getComputedStyle(document.documentElement).getPropertyValue(
				"--wp--preset--font-size--normal"
			)
		)
	);
};

export default pxToEm;
